import axiosWrapper, { InterceptorOptions } from './axios-wrapper'
import {
  setUserLoading,
  setUserLoggedIn,
  setUserLoggedOut,
} from '../actions/user-actions'
import store from '../store'
import { dispatchEvent } from '../CloudWatch-init'

const api = () =>
  axiosWrapper.create(
    { baseURL: '/' },
    InterceptorOptions.defaultErrorInterceptor,
  )

export function getUser() {
  store.dispatch(setUserLoading())
  return api()
    .get(`/tracer/userinfo`)
    .then((response) => {
      const userInfo = response.data
      store.dispatch(setUserLoggedIn(userInfo))
    })
    .catch((error) => {
      store.dispatch(setUserLoggedOut())
      console.log(error)
    })
}

export function getUserInfo() {
  return api()
    .get(`/tracer/userinfo`)
    .then((response) => response.data)
    .catch((error) => {
      console.log(error)
    })
}

export function login() {
  const queryParameters = new URLSearchParams(window.location.search)
  const loginParams = new URLSearchParams({
    redirect_url: queryParameters.get('redirect_url') || '/',
  })
  if (queryParameters.has('identity_provider'))
    loginParams.set(
      'identity_provider',
      queryParameters.get('identity_provider'),
    )

  if (queryParameters.has('force_login'))
    loginParams.set('force_login', queryParameters.get('force_login'))

  return api()
    .get(`/tracer/login_url?${loginParams.toString()}`)
    .then((response) => {
      if (response.data && response.data.location) {
        window.location = response.data.location
      } else {
        console.log(
          'Error: Failed to retrieve a valid login URL from the server.',
        )
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export function logout(redirectUrl) {
  // Try to get user info for logging
  let userName = null
  let userID = null
  let plant = null
  try {
    const state = store.getState()
    const userData = state.user && state.user.data
    // get plant from localstorage if available
    plant = localStorage.getItem('user-plant') || null
    if (plant) {
      plant = JSON.parse(plant)
    }
    if (userData) {
      userName = userData.username
      userID = userData.client_id
      if (!plant) {
        plant =
          userData.plants && userData.plants[0] ? userData.plants[0] : null
      }
    }
  } catch (e) {}

  // Send log event and wait for it to complete (but not block forever)
  const logPromise =
    dispatchEvent && typeof dispatchEvent === 'function'
      ? Promise.resolve(
          dispatchEvent('USER_LOG_OFF', {
            userName,
            userID,
            timestamp: Date.now(),
            plant,
          }),
        )
      : Promise.resolve()

  // Wait up to 500ms for the log event, then redirect
  return logPromise
    .then(() => {
      return new Promise((resolve) => setTimeout(resolve, 200))
    })
    .finally(() => {
      if (!redirectUrl) {
        const queryParameters = new URLSearchParams(window.location.search)
        redirectUrl = queryParameters.has('redirect_url')
          ? queryParameters.get('redirect_url')
          : '/'
      }
      api()
        .get(
          `/tracer/logout_url?redirect_url=${encodeURIComponent(redirectUrl)}`,
        )
        .then((response) => {
          if (response.data && response.data.location) {
            window.location = response.data.location
          } else {
            console.log(
              'Error: Failed to retrieve a valid logout URL from the server.',
            )
          }
        })
        .catch((error) => {
          console.log(error)
        })
    })
}

export function auth0callback() {
  return api()
    .get(`/tracer/auth0callback${window.location.search}`, {
      withCredentials: true,
    })
    .then((response) => {
      if (response.data && response.data.location) {
        window.location = response.data.location
      } else {
        console.log(
          'Error: Failed to retrieve a valid Auth0 callback redirect URL from the server.',
        )
        window.location = '/'
      }
    })
    .catch((error) => {
      console.log(error)
    })
}
